import { render, staticRenderFns } from "./HomeMemberList.vue?vue&type=template&id=afd27f14&scoped=true&"
import script from "./HomeMemberList.vue?vue&type=script&lang=js&"
export * from "./HomeMemberList.vue?vue&type=script&lang=js&"
import style0 from "./HomeMemberList.vue?vue&type=style&index=0&id=afd27f14&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afd27f14",
  null
  
)

export default component.exports